import moment from 'moment'
import { rgb } from 'polished'
const config = {
  ui: {
    headerHeight: 46,
    controlWidth: 200,
    chartWidth: 600,
    chartHeight: 150,
    colors: {
      primary: rgb(42, 139, 187),
      secondary: rgb(56, 100, 152),
      accent: rgb(127, 200, 213),
      light: rgb(255, 255, 247),
      monitoring: rgb(0, 191, 255),
      forecasting: rgb(25, 25, 152),
      scenario: rgb(25, 25, 25),
      optimization: rgb(0, 182, 181),
      dark: rgb(25, 25, 25)
    },
    map: {
      defaultCenter: {
        lat: 13.906569, lng: 100.534123
      },
      defaultZoom: 10
    }
  },
  app: {
    monitoring: {
      dataTypeId: 1,
      title: 'Monitor'
    },
    forecasting: {
      dataTypeId: 2,
      title: 'Forecast'
    },
    scenario: {
      dataTypeId: 2,
      typeIds: [5],
      title: 'Scenario'
    },
    common: {

    },
    defaults: {
      responseDataTypes: {
        1: [1]
      }
    },
    categories: [{
      id: 1,
      name: 'อัตราการระบายน้ำ',
      unit: 'm³/s',
      chart: 'line'
    }, {
      id: 2,
      name: 'ปริมาณน้ำฝน',
      unit: 'mm',
      chart: 'intervalDodge'
    }, {
      id: 3,
      name: 'สภาพน้ำทะเลหนุน',
      unit: 'm',
      chart: 'line'
    }],
    parameters: [{
      id: 1,
      name: 'ความเค็ม',
      min: 0,
      max: 35,
      unit: 'g/l',
      scales: [
        [0.00, rgb(116, 171, 61)],
        [0.20, rgb(247, 206, 70)],
        [0.25, rgb(200, 42, 56)]
      ]
    }, {
      id: 2,
      name: 'อุณหภูมิ',
      min: 0,
      max: 35,
      unit: '°C'
    }, {
      id: 4,
      name: 'การนำไฟฟ้า',
      min: 0,
      max: 2000,
      unit: 'μS/cm'
    }, {
      id: 5,
      name: 'กรด-ด่าง',
      min: 0,
      max: 8,
      unit: 'pH'
    }, {
      id: 3,
      name: 'ความลึก',
      min: 0,
      max: 4,
      unit: 'm'
    }],
    flowPatterns: [{
      id: 1,
      minVolumn: false,
      minDuration: false,
      maxVolumn: false,
      maxDuration: false
    }, {
      id: 2,
      minVolumn: true,
      minDuration: false,
      maxVolumn: false,
      maxDuration: false
    }, {
      id: 3,
      maxVolumn: true,
      maxDuration: true,
      minVolumn: true,
      minDuration: true
    }, {
      id: 4,
      minVolumn: true,
      minDuration: true,
      maxVolumn: true,
      maxDuration: true
    }]
  },
  // now: moment('2018-04-04').format('YYYY-MM-DD HH:mm:ss')
  now: {
    monitoring: moment(),
    forecasting: moment(),
    scenario: moment()
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js